
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 448"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"24","y":"24","width":"400","height":"400","rx":"80","ry":"80","fill":"none","stroke":"currentColor","stroke-width":"48"}}),_c('path',{attrs:{"d":"M280 120h48V88h-48c-44 0-80 36-80 80v8h-32v48h32v152h48V224h48l12-48h-60v-8c0-18 14-32 32-32z","fill":"currentColor"}})])
          )
        }
      }
    